/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Badge_View_OnlyInputs */

const vi_grower_area_camera_badge_view_only = /** @type {(inputs: Grower_Area_Camera_Badge_View_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ xem`)
};

/**

* @param {Grower_Area_Camera_Badge_View_OnlyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_badge_view_only = /** @type {((inputs?: Grower_Area_Camera_Badge_View_OnlyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Badge_View_OnlyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_badge_view_only(inputs)
});